import { render } from "./TextInRed.vue?vue&type=template&id=1e5ae02d"
import script from "./TextInRed.vue?vue&type=script&lang=js"
export * from "./TextInRed.vue?vue&type=script&lang=js"

import "./TextInRed.vue?vue&type=style&index=0&id=1e5ae02d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__